export const SelectedLayerNavbar = {
  if: (el) => true || el.getUserSettings('allowTitleOnArtboard'),
  state: {
    value: {}
  },
  EditorTools: {
    padding: '0',
    margin: '0',
    hide: (el, s) => s.isEditMode,
    gap: 'U',
    childExtends: 'NavbarButton',
    AddBtn: {
      order: '-1',
      icon: 'plus',
      title: (el) => el.call('polyglot', 'editor.layerNavbar.addChildren'),
      onClick: (ev, el, s) => {}
    },
    Remove: {
      icon: 'trash',
      title: (el) => el.call('polyglot', 'common.action.remove')
    },
    TextNavbarButtonDropdown: {},
    ContextBtn: {
      icon: 'three dots vertical',
      title: (el) => el.call('polyglot', 'editor.layerNavbar.options'),
      onClick: (ev, el, s) => {
        el.activateContext(ev, s.key)
      },
      order: 3
    }
  },
  EditorPositionNavbar: null,
  NavbarButtonSet_title: null,
  NavbarButtonSet_meta: null,
  extends: 'EditNavbar',
  fontSize: 'Y2',
  position: 'absolute',
  bottom: '100%',
  margin: 'Z -',
  left: '50%',
  width: 'auto',
  transition: 'X opacity defaultBezier',
  padding: '0 X',
  round: 'radiusControl',
  top: 'auto',
  pointerEvents: 'auto',
  theme: 'common-box',
  // Card-outline on a floating island over live canvas content
  // (design-direction.md §8) — the prescribed separation for a floating
  // toolbar is elevation (DESIGN_LANGUAGE §2.3 `float`), not a stroke; same
  // fix as MainCanvasNavbar.js.
  shadow: 'float',
  transform: 'translate3d(-50%, 0, 1px)'
}
